var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"picnic-content-editor"},[_c('div',{staticClass:"picnic-fieldset-wrap picnic-fieldset-wrap--dark"},[_c('div',{ref:"wrapper",staticClass:"ps-editor picnic-content-editor__wrapper picnic-markdown"})])])}
var staticRenderFns = []

export { render, staticRenderFns }